// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2TyBp","title":"InfoRow_title__1-7jh"};